import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-gray-900 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="grid md:grid-cols-3 gap-8"
        >
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_tint-masters-chi/artifacts/rl203nw7_IMG_0650.PNG" 
              alt="Tint Garage Logo"
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-400 mb-4">
              Professional auto window tinting services in Chicago. Premium quality films with lifetime warranty.
            </p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="#about" className="text-gray-400 hover:text-gold-500 transition-colors">About Us</a></li>
              <li><a href="#options" className="text-gray-400 hover:text-gold-500 transition-colors">Tinting Options</a></li>
              <li><a href="#comparison" className="text-gray-400 hover:text-gold-500 transition-colors">Comparison</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-gold-500 transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-gray-400">
                <MapPin className="w-5 h-5 text-gold-500 mt-0.5" />
                <span>9824 Industrial Dr, Bridgeview, IL 60455</span>
              </li>
              <li className="flex items-center space-x-2 text-gray-400">
                <Phone className="w-5 h-5 text-gold-500" />
                <span>(773) 690-2541</span>
              </li>
              <li className="flex items-center space-x-2 text-gray-400">
                <Mail className="w-5 h-5 text-gold-500" />
                <span className="break-all">tintedbyj@gmail.com</span>
              </li>
            </ul>
          </div>
        </motion.div>

        <div className="border-t border-gray-900 mt-8 pt-8 text-center text-gray-500">
          <p>&copy; 2024 Tint Garage. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
